<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">{{title}}</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="tables.device_info.dialogAdd=true">新增</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="clickUpload()">匯入</v-btn>
          <input type="file" accept=".xlsx" style="display: none;" ref="fileUpload" @change="uploadFile">
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile(tables.device_info)" :loading="tables.isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.device_info.page"
            :length="tables.device_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.device_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="tables.device_info.rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.device_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-header
        hide-default-footer
        :headers="tables.device_info.headers"
        :items="tables.device_info.data"
        :items-per-page="tables.device_info.rows"
        :loading="tables.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.device_info.headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header, tables.device_info)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&tables.device_info.sortItem===header.value">
                    <v-icon v-if="tables.device_info.sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="header in tables.device_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='action'">
                <v-icon
                  size = "35"
                  color="primary"
                  @click="editData(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  @click="openDeleteDialog(tables.device_info, item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="800px" v-model="tables.device_info.dialogAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogTitle}}</v-card-title>
          <v-card-text>
            <v-form :ref="tables.device_info.formEditRef">
              <div class="rowDiv contentCenter">
                <div style="width:196px">
                  <v-text-field
                    label="出廠編號"
                    v-model="tables.device_info.selectedData.device_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                    :disabled='tables.device_info.isEdit'
                  ></v-text-field>
                </div>
                <div style="width:196px" class="ml-2">
                  <v-select
                    label="種類"
                    :items="dictionary.deviceTypeList"
                    outlined
                    class="rounded-lg"
                    dense
                    v-model="tables.device_info.selectedData.device_type"
                    hide-details
                    :rules="rules.content"
                  >
                  </v-select>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:400px">
                  <v-text-field
                    label="P2PID"
                    v-model="tables.device_info.selectedData.device_p2pid"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:196px" class="">
                  <v-text-field
                    label="序號"
                    v-model="tables.device_info.selectedData.device_sn"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
                <div style="width:196px" class="ml-2">
                  <v-text-field
                    label="MAC位址"
                    v-model="tables.device_info.selectedData.device_mac"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:196px" class="">
                  <v-text-field
                    label="供應商"
                    v-model="tables.device_info.selectedData.device_kind"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
                <div style="width:196px" class="ml-2">
                  <v-text-field
                    label="型號"
                    v-model="tables.device_info.selectedData.device_model"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:200px">
                  <v-switch
                    class="ma-0 pa-0"
                    :label="'鎖定中：' + BooleanText2YN(tables.device_info.selectedData.device_lock)"
                    v-model="tables.device_info.selectedData.device_lock"
                    true-value="True"
                    false-value="False"
                  >
                  </v-switch>
                </div>
                <div style="width:200px" class="ml-2">
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog(tables.device_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData(tables.device_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.device_info.dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除設備</v-card-title>
          <v-card-text>
            <v-form :ref="tables.device_info.formDeleteRef">
              <div class="rowDiv contentCenter">
                <div style="width:196px">
                  <v-text-field
                    label="出廠編號"
                    v-model="tables.device_info.selectedData.device_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:196px" class="ml-2">
                  <v-select
                    label="種類"
                    :items="dictionary.deviceTypeList"
                    outlined
                    class="rounded-lg"
                    dense
                    v-model="tables.device_info.selectedData.device_type"
                    hide-details
                    :rules="rules.content"
                    readonly 
                  >
                  </v-select>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:400px" class="mt-2">
                  <v-text-field
                    label="P2PID"
                    v-model="tables.device_info.selectedData.device_p2pid"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly 
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:196px" class="mt-2">
                  <v-text-field
                    label="序號"
                    v-model="tables.device_info.selectedData.device_sn"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly 
                  ></v-text-field>
                </div>
                <div style="width:196px" class="mt-2 ml-2">
                  <v-text-field
                    label="MAC位址"
                    v-model="tables.device_info.selectedData.device_mac"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:196px" class="mt-2">
                  <v-text-field
                    label="供應商"
                    v-model="tables.device_info.selectedData.device_kind"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:196px" class="mt-2 ml-2">
                  <v-text-field
                    label="型號"
                    v-model="tables.device_info.selectedData.device_model"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:196px" class="mt-2">
                  <v-text-field
                    label="鎖定中"
                    v-model="tables.device_info.selectedData.device_lock"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeleteDialog(tables.device_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteDevice(tables.device_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebar.width"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebar.open" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            :class="sidebar.iconClass"
            @click="sidebar.open=!sidebar.open"
          >{{sidebar.icon}}</v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebar.open">
          <v-card-title style="height:50px;" class="searchTitle">出廠編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="tables.device_info.search.device_id.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">P2PID</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="tables.device_info.search.device_p2pid.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">MAC位址</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="tables.device_info.search.device_mac.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>

import Service from '../service/service'
export default {
  name: 'All_Device_Info',
  data: () => ({
    title: '設備匯入作業',
    tables: {
      isLoading: false,
      isExporting: false,
      device_info: {
        formEditRef: 'newDeviceForm',
        formDeleteRef: 'deleteForm',
        urlGet: 'all_device_info/getPageData',
        urlAdd: 'all_device_info/Add',
        urlUpdate: 'all_device_info/update',
        urlDelete: 'all_device_info/del',
        urlExport: 'all_device_info/Export',
        urlImport: 'all_device_info/Import',
        headers: [
          { text: '出廠編號', value: 'device_id', sortable: true },
          { text: '種類', value: 'device_nm', sortable: true },
          { text: 'P2PID', value: 'device_p2pid', sortable: true },
          { text: '序號', value: 'device_sn', sortable: true },
          { text: 'MAC位址', value: 'device_mac', sortable: true },
          { text: '供應商', value: 'device_kind', sortable: true },
          { text: '型號', value: 'device_model', sortable: true },
          { text: '鎖定中', value: 'device_lock', sortable: true },
          { text: '', value: 'action', width: '100', sortable: false }
        ],
        rows: 10,
        sortItem: 'device_id',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          device_id: {
              name: 'device_id',
              value: '',
              displayType: 'like'
          },
          device_p2pid: {
              name: 'device_p2pid',
              value: '',
              displayType: 'like'
          },
          device_mac: {
              name: 'device_mac',
              value: '',
              displayType: 'like'
          }
        },
        data: [],
        selectedData: { 
          device_id: '',
          device_type: '',
          device_p2pid: '',
          device_sn: '',
          device_mac: '',
          device_kind: '',
          device_model: '',
          device_lock: false,
        },
        isEdit: false,
        dialogAdd: false,
        dialogDelete: false
      }
    },
    rules: {
      content: [v => !!v || 'Required']
    },
    sidebar: {
      open: true, 
      width: 260,
      icon: 'mdi-arrow-expand-left',
      iconClass: 'mr-5'
    },
    dictionary: {
      deviceTypeList: []
    }
  }),
  mounted: function () {
    this.getDictionary()
  },
  watch: {
    'sidebar.open' () {
        this.sidebar.width = this.sidebar.open ? 260 : 70
        this.sidebar.icon = this.sidebar.open ? 'mdi-arrow-expand-left' : 'mdi-tune-variant'
        this.sidebar.iconClass = this.sidebar.open ? 'mr-5' : 'mr-5 my-5'
    },
    'tables.device_info.page': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData(this.tables.device_info) }
      }
    },
    'tables.device_info.rows': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.device_info.page === 1 ? this.getPageData(this.tables.device_info) : this.tables.device_info.page = 1 }
      }
    },
    'tables.device_info.search.device_id.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.device_info.page === 1 ? this.getPageData(this.tables.device_info) : this.tables.device_info.page = 1 }
      }
    },
    'tables.device_info.search.device_p2pid.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.device_info.page === 1 ? this.getPageData(this.tables.device_info) : this.tables.device_info.page = 1 }
      }
    },
    'tables.device_info.search.device_mac.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.device_info.page === 1 ? this.getPageData(this.tables.device_info) : this.tables.device_info.page = 1 }
      }
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    dialogTitle () {
      if (this.tables.device_info.isEdit) {
        return '編輯設備'
      } else {
        return '新增設備'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header, table) {
      if (!header.sortable) return

      if (header.value === table.sortItem) {
        table.sortOrder = !table.sortOrder
      } else {
        table.sortOrder = true
        table.sortItem = header.value
      }
      this.getPageData(table)
    },
    getDictionary () {
      var parm = ['device_type_info']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var deviceTypeIndex = response.data.map(function (item) { return item.dicNo }).indexOf('device_type_info')
            var deviceTypeList = response.data[deviceTypeIndex].data
            deviceTypeList.forEach(element => {
              var deviceType = {
                value: '' + element.key,
                text: '' + element.value
              }
              this.dictionary.deviceTypeList.push(deviceType)
            })
            this.getPageData(this.tables.device_info)
          }
        })
    },
    getPageData (table) {
      this.tables.isLoading = true
      table.pageCount = 0
      table.data = []
      var wheres = []
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        page: table.page,
        rows: table.rows,
        order: table.sortOrder ? 'desc' : 'asc',
        sort: table.sortItem,
        wheres: JSON.stringify(wheres),
        url: table.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            table.total = response.data.total
            table.pageCount = Math.ceil(table.total / table.rows)
            table.data = response.data.rows
            table.data.forEach(element => {
              var deviceType = this.dictionary.deviceTypeList.find(x => x.value === ('' + element.device_type))
              if(deviceType) {
                element.device_nm = deviceType.text
              }
            })
          }
        })
      .finally(() => {
        this.tables.isLoading = false
      })
    },
    exportFile (table) {
      this.tables.isExporting = true
      var wheres = []
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        wheres: JSON.stringify(wheres),
        url: table.urlExport
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = this.title + '.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.tables.isExporting = false
      })
    },
    saveData (table) {
      if (this.$refs[table.formEditRef].validate()) {
        var url = table.isEdit ? table.urlUpdate : table.urlAdd
        Service.updateData(table.selectedData, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              this.closeDialog(table)
            }
          })
      }
    },
    closeDialog (table) {
      table.isEdit = false
      table.dialogAdd = false
      this.resetSelectedData()
      if (this.$refs[table.formEditRef]) {
        this.$refs[table.formEditRef].resetValidation()
      }
      // // 暫時特別重取頁面資料
      // this.getPageData(table)
    },
    clickUpload () {
      this.$refs.fileUpload.click()
    },
    editData (item) {
      var table = this.tables.device_info
      var selectedData = table.selectedData
      selectedData.device_id = item.device_id
      selectedData.device_type = item.device_type
      selectedData.device_p2pid = item.device_p2pid
      selectedData.device_sn = item.device_sn
      selectedData.device_mac = item.device_mac
      selectedData.device_kind = item.device_kind
      selectedData.device_model = item.device_model
      selectedData.device_lock = item.device_lock
      table.isEdit = true
      table.dialogAdd = true
    },
    uploadFile (event) {
      var table = this.tables.device_info
      this.excLoading = true
      const file = event.target.files
      this.photoImg = file[0]
      var fileForm = new FormData()
      fileForm.append('fileInput', file[0], file[0].name)
      Service.uploadFile(fileForm, table.urlImport)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.getPageData(table)
            this.showAlert('success', response.data.message)
          }
          this.excLoading = false
          // 清除 input 內的文字，提供相同檔案重複上傳的功能
          this.$refs.fileUpload.value = ''
        })
    },
    openDeleteDialog (table, item) {
      table.dialogDelete = true
      table.selectedData.device_id = item.device_id
      table.selectedData.device_type = item.device_type
      table.selectedData.device_p2pid = item.device_p2pid
      table.selectedData.device_sn = item.device_sn
      table.selectedData.device_mac = item.device_mac
      table.selectedData.device_kind = item.device_kind
      table.selectedData.device_model = item.device_model
      table.selectedData.device_lock = item.device_lock
    },
    closeDeleteDialog (table) {
      table.dialogDelete = false
      this.resetSelectedData()
      if (this.$refs[table.formDeleteRef]) {
        this.$refs[table.formDeleteRef].resetValidation()
      }
    },
    deleteDevice (table) {
      if (this.$refs[table.formDeleteRef].validate()) {
        
        var deleteList = []
        deleteList.push(table.selectedData.device_id)
        Service.deleteData(deleteList, table.urlDelete)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              table.dialogDelete = false
              this.resetSelectedData()
            }
          })
      }
    },
    resetSelectedData () {
      var selectedData = this.tables.device_info.selectedData
      selectedData.device_id = ''
      selectedData.device_type = ''
      selectedData.device_p2pid = ''
      selectedData.device_sn = ''
      selectedData.device_mac = ''
      selectedData.device_kind = ''
      selectedData.device_model = ''
      selectedData.device_lock = false
    },
    BooleanText2YN (value) {
      if (value === null || value === '') {
        return '未設定'
      }
      else if (value === false) {
        return 'N'
      }
      else if (value.toLowerCase() === 'false') {
        return 'N'
      }
      return 'Y'
    },
  }
}
</script>
